import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PropTypes} from 'prop-types';
import {I18n} from 'react-redux-i18n';
import Switch from "react-switch";
import StringUtils from "../../../utils/StringUtils";

const ExpandSwitches = ({
    menuOpened,
    handleCollapseGroupClicked,
    permissionGroups,
    handlePermissionChanged,
    handlePermissionGroupChanged,
    disabled,
}) => {
    return (
        <div className="expand-switches-outer-box">
            {permissionGroups.map(({groupKey, permissions}) => {
                const menuIsOpened = menuOpened === groupKey;
                const allOptionSelected = permissions.findIndex(p => {
                    return p.value === false;
                }) === -1;
                const noOptionSelected = permissions.findIndex(p => {
                    return p.value === true;
                }) === -1;
                const i18nGroupKey = StringUtils.snakeToCamel(groupKey.toLowerCase());

                return (
                    <div className="expand-switches-parent" key={groupKey}>
                        <div className="group-box" style={{borderBottom: "1.5px solid #afafaf"}}>
                            <span
                                className={"expand-switches-title " + (menuIsOpened ? "isOpen" : "")}
                                onClick={() => handleCollapseGroupClicked(groupKey)}
                            >
                                {menuIsOpened ?
                                    <FontAwesomeIcon icon={['fas', 'angle-up']}/> :
                                    <FontAwesomeIcon icon={['fas', 'angle-down']}/>
                                }
                                <span className={"pl-3"}>
                                    {I18n.t(i18nGroupKey + '.permissions.' + groupKey)}
                                </span>
                            </span>
                            <span className="switch">
                                <Switch
                                    onChange={() => handlePermissionGroupChanged(groupKey, !allOptionSelected)}
                                    checked={!noOptionSelected}
                                    onColor={allOptionSelected ? '#0080FF' : noOptionSelected ? '#888888' : '#F5C423'}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    width={51}
                                    height={32}
                                    disabled={disabled}
                                />
                            </span>
                        </div>
                        {permissions
                            .map(({name, value}) => (
                                <div
                                    key={groupKey + "_" + name}
                                    className={"ml-3 expand-switches-child " + (menuIsOpened ? "isOpen " : "")}
                                >
                                    <span
                                        className={"expand-switches-child-title"}> {I18n.t(i18nGroupKey + '.permissions.' + name)}</span>
                                    <span className="switch">
                                        <Switch
                                            onChange={() => handlePermissionChanged(groupKey, name, !value)}
                                            checked={value}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            width={51}
                                            height={32}
                                            disabled={disabled}
                                        />
                                    </span>

                                </div>)
                            )}
                    </div>
                )
            })}
        </div>
    );
};

ExpandSwitches.propTypes = {
    menuOpened: PropTypes.string,
    handlePermissionChanged: PropTypes.func.isRequired,
    handleCollapseGroupClicked: PropTypes.func.isRequired,
    handlePermissionGroupChanged: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    permissionGroups: PropTypes.arrayOf(
        PropTypes.shape({
            menuOpened: PropTypes.bool,
            groupKey: PropTypes.string,
            permissions: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    value: PropTypes.bool.isRequired
                })
            ).isRequired
        })
    )
};

export default ExpandSwitches;